<div (onFileDropped)="uploadExterneBefundmitteilung($event)" kieneDropFile style="padding: 24px">
    <!-- 1. Zeile -->
    <div class="one-row">
        <div class="one-row" style="width: 50%; margin-bottom: 16px">
            <button (click)="goBack()" mat-icon-button>
                <mat-icon>chevron_left</mat-icon>
            </button>
            <h1 style="margin-bottom: 0"> Befundmitteilung {{ befundmitteilung?.tagebuch_nr || "(neu)" }} </h1>
            <span class="spacer"></span>
        </div>

        <span class="spacer"></span>

        <mat-select
            *ngIf="antibiogramme?.length > 0"
            [placeholder]="'Antibiogramme'"
            style="width: 140px"
            (selectionChange)="openAntibiogramm($event)"
            [formControl]="antibiogrammCtrl"
        >
            <mat-option *ngFor="let a of antibiogramme" [value]="a">
                <div class="one-row">
                    <span>{{ a.tagebuch_nr }}</span>
                    <mat-icon>open_in_new</mat-icon>
                </div>
            </mat-option>
        </mat-select>

        <button
            (click)="transformToAntibiogramm()"
            *kienePermission="[1336]"
            [disabled]="befundmitteilung?.status_id === 12"
            mat-icon-button
            matTooltip="neues Antibiogramm erzeugen"
        >
            <mat-icon>add_circle_outline</mat-icon>
        </button>
        <button
            (click)="freigabeEntfernen()"
            *kienePermission="[1312]"
            [disabled]="befundmitteilung?.status_id !== 13"
            mat-icon-button
            matTooltip="Freigabe entfernen"
        >
            <mat-icon>undo</mat-icon>
        </button>
        <button
            (click)="save()"
            *kienePermission="[1312]"
            [disabled]="befundmitteilung?.status_id === 12"
            mat-icon-button
            matTooltip="Speichern"
        >
            <mat-icon>save</mat-icon>
        </button>
        <button
            (click)="addFilesToBefundmitteilung($event)"
            *kienePermission="[1322]"
            [disabled]="!befundmitteilung?.befund_id"
            mat-icon-button
            matTooltip="Externe Befunde anhängen"
        >
            <mat-icon>attach_file</mat-icon>
        </button>
        <button (click)="openExterneBefundeDialog()" [disabled]="befundmitteilungenExtern.length < 1" mat-icon-button>
            <mat-icon [matBadge]="befundmitteilungenExtern.length" matBadgeColor="accent">folder</mat-icon>
        </button>
        <button
            (click)="openPdfPreview($event)"
            *kienePermission="[1315]"
            [disabled]="!befundmitteilung?.befund_id"
            mat-icon-button
            matTooltip="PDF Vorschau"
        >
            <mat-icon>picture_as_pdf</mat-icon>
        </button>
    </div>

    <!-- 2. Zeile -->

    <div *kienePermission="[1313]" class="one-row">
        <mat-form-field style="width: 200px">
            <mat-label>Probenentnahmedatum</mat-label>
            <input [formControl]="probenentnahmeCtrl" [matDatepicker]="probenentnahmePicker" matInput />
            <mat-datepicker-toggle [for]="probenentnahmePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #probenentnahmePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="width: 200px">
            <mat-label>Untersuchungsbeginn</mat-label>
            <input [formControl]="untersuchungsbeginnCtrl" [matDatepicker]="untersuchungsbeginnPicker" matInput />
            <mat-datepicker-toggle [for]="untersuchungsbeginnPicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #untersuchungsbeginnPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="width: 210px">
            <mat-label>Untersuchungsende</mat-label>
            <input [formControl]="untersuchungsendeCtrl" [matDatepicker]="untersuchungsendePicker" matInput />
            <mat-datepicker-toggle [for]="untersuchungsendePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #untersuchungsendePicker></mat-datepicker>
        </mat-form-field>

        <div style="display: flex; flex-direction: column; min-width: 400px">
            <kiene-autocomplete
                (elementSelected)="setSelectedClient($event)"
                [disabled]="isClientDisabled()"
                [displayFields]="['kunde_nr_intern', 'bezeichnung', 'zusatz', 'unternehmensgruppe']"
                [genericApiUrl]="'kunde/read.php'"
                [kieneObject]="currentClient"
                [mapperDisplayFields]="['kunde_nr_intern', 'bezeichnung', 'zusatz', 'unternehmensgruppe']"
                [params]="kundeSearchParams"
                [placeholder]="'Kunde'"
                [separator]="' - '"
                [panelWidth]="'600px'"
                [focus]="false"
                style="min-width: 400px"
            >
            </kiene-autocomplete>
            <mat-checkbox [(ngModel)]="inaktiveBetriebeAnzeigen" (change)="inaktiveBetriebeAnzeigenChanged($event)">
                Inaktive Betriebe anzeigen
            </mat-checkbox>
        </div>

        <kiene-autocomplete
            #gruppeAutocomplete
            (elementSelected)="setSelectedGruppe($event)"
            [disabled]="!currentClient || isClientDisabled()"
            [displayFields]="['bezeichnung', 'stall']"
            [genericApiUrl]="'gruppe/read_akt.php'"
            [kieneObject]="currentGruppe"
            [mapperDisplayFields]="['bezeichnung', 'stall']"
            [params]="currentClientParams"
            [placeholder]="'Gruppe'"
            [separator]="' - '"
            style="min-width: 400px"
        >
        </kiene-autocomplete>
    </div>

    <div *ngIf="!hasPermission(1313)" class="one-row" style="margin-bottom: 12px">
        <span
            >Tagebuchnummer: <strong>{{ befundmitteilung?.tagebuch_nr }}</strong></span
        >
        <span
            >Probenentnahmedatum: <strong>{{ befundmitteilung?.probenentnahme | date: "dd.MM.yyyy" }}</strong></span
        >
        <span
            >Untersuchungsbeginn: <strong>{{ befundmitteilung?.eingang | date: "dd.MM.yyyy" }}</strong></span
        >
        <span
            >Untersuchungsbeginn: <strong>{{ befundmitteilung?.ausgang | date: "dd.MM.yyyy" }}</strong></span
        >
        <span
            >Gruppe: <strong>{{ befundmitteilung?.gruppe }}</strong></span
        >
    </div>

    <!-- 3. Zeile -->

    <div *kienePermission="[1313]" class="one-row">
        <mat-form-field style="min-width: 400px; margin-right: 12px">
            <mat-label>Untersuchungsmaterial</mat-label>
            <input
                (textChanged)="replaceUntersuchungsmaterial($event)"
                [formControl]="untersuchungsmaterialCtrl"
                kieneTextProposal
                matInput
            />
        </mat-form-field>

        <mat-form-field style="min-width: 20%; margin-right: 12px">
            <mat-label>Pr&uuml;fer</mat-label>
            <mat-select [compareWith]="prueferComparator" [formControl]="prueferCtrl">
                <mat-option>Kein Pr&uuml;fer ausgew&auml;hlt</mat-option>
                <mat-option *ngFor="let p of pruefer" [value]="p">{{ p.bezeichnung }}</mat-option>
            </mat-select>
        </mat-form-field>

        <span style="margin-right: 12px">Kategorie:</span>
        <span
            class="kategorie-kreis"
            (click)="kategorieBearbeiten()"
            [style.cursor]="befundmitteilung?.rechnung_id || befundmitteilung?.status_id === 12 ? '' : 'pointer'"
            ><strong>{{ befundmitteilung?.kategorie }}</strong></span
        >
        <span class="spacer"></span>

        <div *kienePermission="[1310]">
            <button
                (click)="freigeben()"
                *ngIf="befundmitteilung?.status_id === 11 || befundmitteilung?.status_id === 15"
                [disabled]="
                    untersuchungsendeCtrl.value == null ||
                    untersuchungsbeginnCtrl.value == null ||
                    untersuchungsmaterialCtrl.value == null ||
                    untersuchungsmaterialCtrl.value == '' ||
                    befundmitteilung.positionen.length === 0 ||
                    prueferCtrl.value == null
                "
                color="accent"
                mat-flat-button
            >
                Befundmitteilung freigeben
            </button>
        </div>
        <div *kienePermission="[1316]">
            <button
                (click)="abschliessen()"
                *ngIf="befundmitteilung?.status_id == 13"
                [disabled]="
                    untersuchungsendeCtrl.value == null ||
                    untersuchungsbeginnCtrl.value == null ||
                    untersuchungsmaterialCtrl.value == null ||
                    untersuchungsmaterialCtrl.value == '' ||
                    befundmitteilung.positionen.length === 0 ||
                    prueferCtrl.value == null
                "
                color="accent"
                mat-flat-button
            >
                Befundmitteilung abschlie&szlig;en
            </button>
        </div>
    </div>

    <div *ngIf="!hasPermission(1313)" class="one-row">
        <span style="margin-right: 24px"
            >Untersuchungsmaterial: <strong>{{ befundmitteilung?.untersuchungsmaterial }}</strong></span
        >
        <span
            >Pr&uuml;fer: <strong>{{ befundmitteilung?.pruefer }}</strong></span
        >
        <span class="spacer"></span>
    </div>

    <!-- Position hinzufuegen bzw. bearbeiten -->

    <div
        *ngIf="hasPermission(1313) && befundmitteilung?.status_id !== 12"
        style="border: 1px solid gray; border-radius: 5px; padding: 12px"
    >
        <div class="one-row">
            <kiene-article-scan-autocomplete
                #articleScan
                (selectedMaterial)="setSelectedMaterial($event)"
                [gesperrtAusblenden]="true"
                [labor]="true"
                [placeholder]="'Artikel'"
                [lieferantAnzeigen]="true"
                style="width: 50%"
            >
            </kiene-article-scan-autocomplete>

            <mat-form-field style="min-width: 120px">
                <mat-label>Menge</mat-label>
                <input [formControl]="mengeCtrl" matInput type="number" min="1" />
            </mat-form-field>

            <mat-checkbox [formControl]="imBefundAnzeigenCtrl">Im Befund anzeigen</mat-checkbox>
            <mat-checkbox
                [formControl]="nichtAbrechnenCtrl"
                matTooltip="Position erscheint auf der Rechnung mit 0,00 €"
                >Nicht abrechnen</mat-checkbox
            >
        </div>

        <mat-form-field style="width: 100%">
            <mat-label>Text</mat-label>
            <textarea
                (textChanged)="replaceFreitext($event)"
                [formControl]="textCtrl"
                kieneTextProposal
                matInput
                rows="3"
            ></textarea>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Text Untersuchungsauftrag</mat-label>
            <textarea
                (textChanged)="replaceFreitextExtern($event)"
                [formControl]="freitextExternCtrl"
                kieneTextProposal
                matInput
                rows="1"
            ></textarea>
        </mat-form-field>

        <div class="one-row">
            <mat-form-field style="min-width: 800px; width: 67%">
                <mat-label>Fu&szlig;zeile</mat-label>
                <input
                    (textChanged)="replaceFusszeile($event)"
                    [formControl]="fusszeileCtrl"
                    kieneTextProposal
                    matInput
                    rows="3"
                />
            </mat-form-field>
            <span class="spacer"></span>

            <button (click)="savePosition()" color="accent" mat-flat-button style="margin-left: 24px">
                Speichern
            </button>
            <span class="spacer"></span>
            <button (click)="resetPosition()" color="accent" mat-stroked-button> Neu/Position zurücksetzen</button>
        </div>

        <div *ngIf="isIdexxMaterial()">
            <div style="width: 100%; height: 1px; background-color: grey"></div>
            <div style="font-size: 1.15em; padding: 1% 0 1% 0">
                Idexx - XChekPlus (Status:
                {{ getTestlaufStatus() ? "abgeschlossen" : "offen" }})
            </div>
            <div style="width: 100%">
                <mat-form-field style="width: 25%">
                    <mat-label>Tierart</mat-label>
                    <mat-select [compareWith]="idexxSpeziesComparator" [formControl]="idexx_speziesCtrl">
                        <mat-option *ngFor="let ta of idexx_spezies" [value]="ta">
                            {{ ta.bezeichnung }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field style="width: 25%; margin-left: 2%">
                    <mat-label>Probenart (z.B. Milch, Blut ...)</mat-label>
                    <input [formControl]="idexx_probenartCtrl" matInput />
                </mat-form-field>
            </div>

            <mat-form-field style="width: 100%">
                <mat-label>Testlauf Kommentar</mat-label>
                <textarea
                    (textChanged)="replaceIdexxTestlaufKommentar($event)"
                    [formControl]="idexx_testlaufkommentarCtrl"
                    kieneTextProposal
                    matInput
                    rows="3"
                ></textarea>
            </mat-form-field>
        </div>
    </div>

    <!-- Positionentabelle -->

    <table class="phito-table" style="margin-top: 24px">
        <thead>
            <tr>
                <th></th>
                <th>Position</th>
                <th>Artikel</th>
                <th>Anzahl Proben</th>
                <th>Name auf Befund</th>
                <th>Menge</th>
                <th *kienePermission="[1334]">Einzelpreis</th>
                <th *kienePermission="[1334]">Gesamtpreis</th>
                <th>Im Befund anzeigen</th>
                <th>Nicht abrechnen</th>
                <th>Freitext</th>
                <th>Freitext Untersuchungsauftrag</th>
                <th>Fu&szlig;zeile</th>
                <th></th>
            </tr>
        </thead>
        <tbody (cdkDropListDropped)="dropPosition($event)" cdkDropList class="example-list">
            <tr
                (click)="positionBearbeiten(i)"
                *ngFor="let p of befundmitteilung?.positionen; let i = index"
                [cdkDragData]="p"
                cdkDrag
                cdkDragLockAxis="y"
                class="example-box"
                style="cursor: pointer"
            >
                <td cdkDragHandle style="cursor: grab">
                    <mat-icon>menu</mat-icon>
                </td>
                <td>{{ p.position }}</td>
                <td>{{ p.artikel }}</td>
                <td>{{ p.anzahl_proben }}</td>
                <td>{{ p.bezeichnung_befund }}</td>
                <td>{{ p.artikelmenge }}</td>
                <td
                    *kienePermission="[1334]"
                    clickStopPropagation
                    (click)="openPreisAnpassungDialog(p)"
                    style="min-width: 100px"
                >
                    <span [ngClass]="{ 'preis-link': hasPermission(1285) }"
                        >{{ p.einzelpreis | number: "1.2-2" }} &euro;</span
                    >
                </td>
                <td *kienePermission="[1334]">
                    {{ p.artikelmenge * p.einzelpreis | number: "1.2-2" }}
                    &euro;
                </td>
                <td clickStopPropagation>
                    <mat-checkbox
                        (click)="$event.preventDefault(); toggleAuflisten(p)"
                        [checked]="isAuflistenChecked(p)"
                    ></mat-checkbox>
                </td>
                <td clickStopPropagation>
                    <mat-checkbox
                        (click)="$event.preventDefault(); toggleNichtAbrechnen(p)"
                        [checked]="isNichtAbrechnenChecked(p)"
                        matTooltip="Nicht abrechnen: auf Rechnung mit 0,00 €"
                    ></mat-checkbox>
                </td>
                <td>{{ p.freitext }}</td>
                <td>{{ p.freitext_extern }}</td>
                <td>{{ p.fusszeile }}</td>
                <td>
                    <kiene-delete-button
                        (delete)="positionEntfernen(i)"
                        *ngIf="hasPermission(1313) && befundmitteilung?.status_id !== 12"
                    >
                    </kiene-delete-button>
                </td>
                <td *ngIf="isIdexxPosition(p)">
                    <button (click)="openResultDialog(p)" [disabled]="!isAbgeschlossen(p)" mat-icon-button>
                        <mat-icon *ngIf="isAbgeschlossen(p)" matTooltip="Ergebnisse anzeigen">checklist</mat-icon>
                        <mat-icon *ngIf="!isAbgeschlossen(p)" matTooltip="In Bearbeitung">watch_later</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
